export default {
  headerContent: {
    title: 'Atlas Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta DASK',
    description: {
      title:
        'Atlas Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Deprem risk haritasına göre ülkemiz %92 deprem tehlikesi bölgesi içerisindedir. Bu nedenle zorunlu deprem sigortası aslında zorunluluktan daha çok ihtiyaçtır. ',
        'DASK sigortası deprem soncunda ortaya çıkan yangın, yer kayması gibi hasarların meydana getirdiği zararları güvence altına almaktadır.',
        'Atlas Sigorta deprem sigortası ile deprem sonucunda oluşan maddi kayıplara karşı binaları koruma altına almaktadır. '
      ]
    },
    subContent: {
      title: 'DASK Adres Kodu Nedir?',
      content: [
        {
          paragraph:
            'DASK adres kodu konutun açık adresinin uluslararası veri tabanında var olan 10 haneli numaradır. DASK sigortası bu 10 haneli numaraya göre oluşturulmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Atlas Mutuel DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'DASK Sigorta Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası sigorta bedeli poliçe ile teminata alınmış konutun inşa maliyetidir. Bu bedelde sadece konutun yapım maliyeti yer almaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Zorunlu Deprem Sigortası Teminatları Neler?',
      content: [
        {
          paragraph:
            'Atlas Sigorta zorunlu deprem sigortası sunmuş olduğu teminatlar;',
          subList: [
            'Deprem sonrası yer kayması,',
            'Deprem sonrası yangın,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası infilak teminatından oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Zorunlu Deprem Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartları gereğince teminat dışı kalan haller;',
          subList: [
            'Alternatif ikametgah ve işyeri masrafları',
            'Deprem ve deprem sonucu oluşan yangın, infilak, tsunami veya yer kaymasının dışında kalan hasarlar,',
            'Depremden bağımsız olarak, binanın kendi kusurlu yapısı nedeniyle zamanla oluşmuş zararlar,',
            'Enkaz kaldırma masrafları,',
            'Her türlü taşınır mal, eşya ve benzerleri,',
            'İş durması,',
            'Kar kaybı,',
            'Kira mahrumiyeti,',
            'Mali sorumluluklar ve benzeri başkaca ileri sürülebilecek diğer bütün dolaylı zararlar,',
            'Manevi tazminat talepleri,',
            'Tüm bedeni zararlar ve vefat durumu teminat dışıdır.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Sigortasını Kim Yaptırır?',
      content: [
        {
          paragraph:
            'Deprem sigortasını ev sahipleri ve kiracılar yaptırabilir. Fakat poliçe ev sahibinin üzerine olmak zorundadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta (Zorunlu Deprem Sigortası) Geçerlilik Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Deprem sigortası, poliçede yazan başlangıç tarihinden itibaren 1 yıldır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Poliçesinde Hangi Binalar Zorunlu Deprem Sigortası Kapsamındadır?',
      content: [
        {
          paragraph:
            'Genel şartlarda belirtilmiş binalar hariç tüm binalar kapsam dâhilindedir.',
          subList: null
        },
        {
          paragraph: 'Bu binalar;',
          subList: [
            'Tapuya kayıtlı ve özel mülkiyete tabi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar,',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler,',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler,',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler.'
          ]
        },
        {
          paragraph:
            'Zorunlu Deprem Sigortası ayrıca yukarıdaki koşullara uyan;',
          subList: [
            'Kat irtifakı tesis edilmiş binalar,',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar,',
            'Tapu tahsisi henüz yapılmamış kooperatif evleri kapsar.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Zorunlu Deprem Sigortası Kapsamında Yer Alan Konut Bölümleri Nelerdir?',
      content: [
        {
          paragraph:
            'Deprem sigortası genel şartlarına göre kapsam altında olan bölümler;',
          subList: [
            'Temeller',
            'Ana duvarlar',
            'Bağımsız bölümleri ayıran ortak duvarlar',
            'Bahçe duvarları',
            'İstinat duvarları',
            'Tavan ve tabanlar',
            'Merdivenler',
            'Asansörler',
            'Sahanlıklar',
            'Koridorlar',
            'Çatılar',
            'Bacalar',
            'Yapının yukarıdakilerle benzer nitelikteki tamamlayıcı bölümlerinden oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Hangi Binalar Genel Şartlar Gereğince Zorunlu Deprem Sigortası Kapsamında Değildir?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası kapsamı dışında kalan bina türleri aşağıdaki gibidir:',
          subList: [
            '9/11/1983 tarihli ve 2946 sayılı Kamu Konutları Kanununa tâbi olan veya kamu hizmet binası olarak kullanılan binalar ve bağımsız bölümler,',
            'Köy nüfusuna kayıtlı ve köyde sürekli oturanlarca köy yerleşik alanları ve civarında ve mezralarda yapılan binalar,',
            'Tamamı ticari veya sınai amaçla kullanılan binalar,',
            'Projesi bulunmayan ve mühendislik hizmeti görmemiş binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde tadil edildiği veya zayıflatıldığı tespit edilen binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde ilgili mevzuata ve projeye aykırı olarak inşa edilen binalar,',
            'Yetkili kamu kurumları tarafından yıkılmasına karar verilen binalar ile mesken olarak kullanıma uygun olmayan, bakımsız, harap veya metruk binalar,',
            'Köy yerleşimleri -genel olarak gelir düzeyinin düşük olması, binalarda belediye denetiminin bulunmaması ve sigortanın sunumunun zor olması gibi nedenlerle- sigorta kapsamı dışında yer alır. Ancak, köylerde bulunan yapılar için istendiği takdirde İhtiyari Deprem Sigortası yaptırılması mümkündür. Benzer şekilde ticari ve sanayi amaçlar için kullanılan binalar için de İhtiyari Deprem Sigortası yaptırılabilir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Yenileme İndirimi Nedir?',
      content: [
        {
          paragraph:
            'DASK yenileme indirimi sigorta başlangıç tarihinden bitiş tarihleri arasında hasar oluşmaması sonucunda sigortalıya verilen bir ödüldür.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası, sisteme sigortalı ve konut bilgileri girilerek hesaplaması yapılmaktadır. Bu hesaplama sonucu prim müşteriye ileterek müşteri onayı beklenmektedir. Müşteri onay vermesi sonucunda ödeme bilgisi alınarak poliçe üretimi sağlanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK (Zorunlu Deprem Sigortası) Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Dask sigortası olası bir deprem sonucunda konutun kullanamaz hale gelmesi durumunda hak sahibine bina bedelini ödeyerek büyük maddi kayıpların önüne geçmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK İçin Gerekli Belgeler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası düzenleye bilmek için sigortalıdan birkaç bilgi talep edilmektedir.',
          subList: null
        },
        {
          paragraph: 'Sigortalıdan talep edilen bilgiler;',
          subList: [
            'Sigortalının vergi ve T.C. kimlik numarası, ',
            'Sigortalanacak yerin açık adresi, ',
            'Binanın inşa yılı,',
            'Binanın yapı tarzı,',
            'Binanın kaç katlı olduğu, ',
            'Binanın hasar durumu,',
            'Konutun brüt yüz ölçümü (m²), ',
            'Konutun kullanım şekli gereklidir.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Zorunlu Deprem Sigortası Yaptırmadan Konut Poliçesi Yaptırmak Mümkün Mü?',
      content: [
        {
          paragraph:
            'Konut sigortası yaptırmak için deprem sigortası gerekmemektedir. ',
          subList: null
        },
        {
          paragraph:
            'DASK olmadan konut sigortası tanzim edilebilir yalnız deprem sonucu oluşan hasarlar kapsam dışı tutulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Nereye Ödenir?',
      content: [
        {
          paragraph:
            'Sigortalı deprem sigortası ödemesini sigorta şirketine yapmaktadır. Yapılan ödeme, havuzda toplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Zorunlu Deprem Sigortasında Tazminat Ödenmesi Ne Şekilde Olur?',
      content: [
        {
          paragraph:
            'Hasar oluşması durumunda sigorta şirketi eksper görevlendirerek hasar oluşan yerine giderek değerlendirme yapmaktadır. Yapılan bu değerlendirmeler sigorta şirketine gönderilerek sigorta şirketinden onay beklenmektedir. Sigorta şirketinin onayından sonra konutun sahibine ödeme yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta DASK (Zorunlu Deprem Sigortası) İptali Yapılır Mı?  ',
      content: [
        {
          paragraph:
            'Dask sigortası iptal edilemeyen bir sigorta ürünüdür. Yalnızca konutun devri olması durumunda DASK sigortası konutu yeni alan kişinin üzerine aktarılabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta DASK (Zorunlu Deprem Sigortası) Hasar İhbarı Nereye Yapılır?',
      content: [
        {
          paragraph:
            'Hasar ihbarınızı poliçeyi satın almış olduğunuz acenteye, sigorta şirketlerine veya Alo 125 hattına bildirilebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK (Poliçe) Sorgulama Nereden Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortanızın sorgulamasını DASK’ın sitesi üzerinde yer alan poliçe sorgulama sekmesinden yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Zorunlu Deprem Sigortası Teklifi Almak İçin Ne Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası teklifinizi online veya çağrı merkezimizden alabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Online DASK teklifi almak için başvuru formunda yer alan bilgileri doldurabilir veya çağrı merkezimizle iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Ne Kadar Ödeme Yapar?',
      content: [
        {
          paragraph:
            'DASK sigortası ödemeleri hasarın boyutuna göre değişmektedir. Fakat poliçede yazılı bina bedelini geçmemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Deprem Sigortası Nerede Yapılır?',
      content: [
        {
          paragraph:
            'DASK sigortası düzenlemeye yetkilendirilmiş kişi veya kurumlardan yapılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'alokasko.com olarak uzman hasar ve sigorta danışmanlarımızla konutunuzu güvence altına almaktayız.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK (Poliçe) Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph: 'DASK sigortası hesaplaması konutun bulunduğu adreste bulunan risk derecesine ve konutun büyüklüğüne göre hesaplanmaktadır. Aynı risk bölgesinde bulunan ve yüz ölçümü büyüklüğü aynı olan dairelere çıkan fiyatlar aynıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta DASK Zorunlu Deprem Sigortası Ne Kadar?',
      content: [
        {
          paragraph: 'Zorunlu deprem sigortası dairenin metrekaresi ve binanın bulunduğu adrese göre değişmektedir. Bu sebeple net bir fiyat söylemek mümkün değildir. İstanbul’da 100 metrekare olan bir ev için ortalama çıkan fiyat 270 TL’dir. Bu fiyat konutun bulunduğu adrese göre değişmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Zorunlu Deprem Sigortası Online Nasıl Alınır?',
      content: [
        {
          paragraph: 'Dask sigortasını online olarak almanız mümkün. Bunun için tek yapmanız gereken alokasko.com üzerinden başvuru formunda yer alan bilgileri doldurmaktır.',
          subList: null
        }
      ]
    }
  ]
}
